

<div class="inner-content" [innerHTML]="content | unsafeHtml"></div>
